<template>
  <div class="sub_comment">
    <b-overlay
      :show="frm_loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-media
        v-if="item.show_sub"
        class="mt-1"
      >
        <template #aside>
          <b-avatar
            size="50"
            :src="item.avatar"
            :text="avatarText(item.full_name)"
            variant="light-primary"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <div class="frmComment">
          <b-form-textarea
            v-model="frmSub.content"
            v-autogrow
            class="frm_content font-be-vietnam"
            placeholder="Ý kiến của bạn"
            @input="handleTextArea"
          />
          <b-button
            v-if="frmSub.show_child"
            variant="danger"
            class="btn-icon btn-sm font-be-vietnam"
            @click="onSubmit()"
          >Gửi <feather-icon icon="SendIcon" /></b-button>
        </div>
      </b-media>
    </b-overlay>
    <div class="list_subComment mt-1">
      <b-media
        v-for="(val, index) in itemData"
        :key="index"
      >
        <template #aside>
          <b-avatar
            size="50"
            :src="val.avatar"
            :text="avatarText(val.full_name)"
            variant="light-primary"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <h5 class="mt-0">
          {{ val.full_name }}
        </h5>
        <b-card-text class="mb-0">
          {{ val.content }}
        </b-card-text>
        <div class="block_like_web">
          <span
            v-if="val.is_liked == false"
            class="link_thich font-be-vietnam"
            @click="onLike(val.id, 'liked')"
          ><font-awesome-icon icon="fa-thumbs-up" /> Thích</span>
          <span
            v-else
            class="link_thich"
            style="color: #C92A57;"
            @click="onLike(val.id, 'unliked')"
          ><strong>Bỏ thích</strong></span>
          <span class="time-com font-be-vietnam">{{ val.timeago }}</span>
        </div>
      </b-media>
      <p
        v-if="loading"
        class="mb-0"
      > <b-spinner small /> <span class="pl-1">Loading...</span></p>
      <div v-else>
        <p
          v-if="item.total_sub"
          class="count-reply"
        ><a
            href="javascript:;"
            class="view_all_reply font-be-vietnam"
            @click="loadSubData(item.article_id, item.id)"
          >
            <span class="num_reply_cmt font-be-vietnam">{{ item.total_sub }}</span> trả lời</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BSpinner,
  BImg,
  BAvatar,
  BMedia,
  BButton,
  BLink,
  BCardText,
  BFormTextarea,
  BOverlay,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api'
import { showToast, useRouter, defaultAvatar } from '@/@core/utils/utils';
import store from '@/store';
import useJwt from '@/auth/jwt/useJwt';

import { avatarText } from '@core/utils/filter'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faThumbsUp, faReply, faL } from '@fortawesome/free-solid-svg-icons';
import { TextareaAutogrowDirective } from 'vue-textarea-autogrow-directive'

library.add(faThumbsUp, faReply);
export default {
  components: {
    BImg,
    BLink,
    BButton,
    BMedia,
    BCardText,
    BFormTextarea,
    BOverlay,
    BAvatar,
    FontAwesomeIcon,
    BSpinner,
  },
  directives: {
    autogrow: TextareaAutogrowDirective,
  },
  props: {
    item: {
      type: Object,
      default: () => { },
    },
    frmSub: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      avatarText,
      defaultAvatar,
    }
  },
  setup(props, context) {
    const userData = useJwt.getUser()
    const { route, router } = useRouter();
    const content = ref('')
    const btnShow = ref(false)
    const loading = ref(false)
    const frm_loading = ref(false)
    const currentPage = ref(0)
    const total = ref(0)
    const itemData = ref([])
    const article_id = route.value.params.id;
    const blank = {
      parent_id: '',
      content: '',
      article_id,
      show_child: false,
    }
    // const frmData = ref(JSON.parse(JSON.stringify(blank)))
    // const resetItemData = () => {
    //   frmData.value = JSON.parse(JSON.stringify(blank))
    // }
    return {
      content,
      btnShow,
      loading,
      itemData,
      userData,
      total,
      currentPage,
      frm_loading,
    }
  },
  methods: {
    onLike(id) {
      store.dispatch('comment/like', id)
        .then(response => {
          const result = response.data
          if (result.code == 200) {
            this.itemData = this.itemData.map(val => {
              if (val.id == id) {
                val.is_liked = result.data.is_liked
              }
              return val;
            })
          } else {
            showToast(result.message)
          }
        })
    },
    loadSubData(article_id, parent_id) {
      this.loading = true;
      this.currentPage++
      store.dispatch('comment/fetchData', {
        article_id,
        parent_id,
        page: this.currentPage,
        perPage: this.perPage,
      }).then(response => {
        const result = response.data;
        if (result.code == 200) {
          this.last_page = result.data.last_page
          const number = result.data.data.length;
          this.item.total_sub = this.item.total_sub - number;
          if (this.itemData.length > 0) {
            this.itemData = [...this.itemData, ...result.data.data]
          } else {
            this.itemData = result.data.data
          }
        }
        this.loading = false;
      })
    },
    handleTextArea() {
      this.frmSub.show_child = !!this.frmSub.content
    },
    onSubmit() {
      this.frm_loading = true

      const { content } = this.frmSub
      if (this.frmSub.article_id && content) {
        this.frmSub.parent_id = this.item.id
        store.dispatch('comment/create', this.frmSub).then(response => {
          const result = response.data;
          this.frm_loading = false
          if (result.code == 200) {
            this.item.show_sub = false
            this.frmSub.content = '';
            this.frmSub.show_child = false
            this.frmSub.parent_id = ''
            this.item.total_sub++
            if (this.itemData.length > 0) {
              this.itemData.unshift(result.data)
            }
            showToast(result.message, { variant: 'success' })
          } else {
            showToast(result.message);
          }
        })
      } else {
        showToast('Nhập nội dung bình luận trước khi gủi.')
      }
    },

  },
}
</script>
